import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';

@Component({
  selector: 'app-customfeedback',
  templateUrl: './customfeedback.component.html',
  styleUrl: './customfeedback.component.css'
})
export class CustomfeedbackComponent implements OnInit {
  form: FormGroup;
  data: any = {};

  intervention: any = [];

  allCustomQuestion: any = [];
  selectedQuestions: any[] = [];
  interventionList: any;
  componentList: any;
  dataSource: any[] = [];
  constructor(private fb: FormBuilder, private apiService: ApiService, private toastrService: ToastrService, private router: Router,) {
    this.form = this.fb.group({
      intervention: ['', Validators.required],
      component:['', Validators.required]
    });
  }

  ngOnInit(): void {
    
    this.LoadDetails();
  }

  // Fetch data for intervention and component lists
  LoadDetails() {

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETCUSTOMQUESTIONCREATE).subscribe(
      (result) => {
        if (result.status) {
          
          this.interventionList = result.data.item1;
          this.allCustomQuestion = result.data.item2;
        } else {
          this.toastrService.error('Failed to load data.', 'Error');
        }
      },
      error => this.toastrService.error('An error occurred while fetching data.', 'Error')
    );
  }

  // On selecting an intervention
  onSelectInterventionChange(event: any): void {
    
    var data = {
      interventionId: event.value
    }
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETINTEREST, data).subscribe(
      (result: any) => {
        if (result.status) {
          this.componentList = result.data;
        } else {
          this.toastrService.error('Failed to load components.', 'Error');
        }
      },
      error => this.toastrService.error('An error occurred while fetching components.', 'Error')
    );
  }

  // On selecting a component
  onSelectComponentChange(event: any): void {

    var data = {
      intervensionId: this.form.get('intervention')?.value,
      componentId: this.form.get('component')?.value,
    }

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETCUSTOMQUESTIONCREATED, data).subscribe(
      (result) => {
        if (result.status) {
          this.selectedQuestions = result.data;

          // Remove selected questions from the allCustomQuestion list
          const selectedIds = new Set(this.selectedQuestions.map((q: any) => q.id));
          this.allCustomQuestion = this.allCustomQuestion.filter((q: any) => !selectedIds.has(q.id));

        }
      },
      error => this.toastrService.error('An error occurred while fetching custom questions.', 'Error')
    )

  }

  // Toggle question selection (both on left and right side)
  toggleQuestionSelection(question: any, event: any): void {
    question.selected = event.target.checked;
  }

  // Move selected questions from left to right
  moveSelectedToRight(): void {

    const selected = this.allCustomQuestion.filter((question:any) => question.selected);
    selected.forEach((question:any) => {
      if (!this.selectedQuestions.includes(question)) {
        this.selectedQuestions.push(question);
      }
      // Remove the interest from the filtered list
      question.selected = false; // Reset selection
    });
    this.allCustomQuestion = this.allCustomQuestion.filter((question: any) => !selected.includes(question));
  }

  // Move selected questions from right to left
  moveSelectedToLeft(): void {

    const deselected = this.selectedQuestions.filter((question: any) => question.selected);
    deselected.forEach((question:any) => {
      if (!this.allCustomQuestion.includes(question)) {
        this.allCustomQuestion.push(question);
      }
    });
    this.selectedQuestions = this.selectedQuestions.filter((question: any) => !question.selected);

  }

  // Save data
  onSubmit() {
    
    if (this.form.valid) {
      const data = {
        createdBy: sessionStorage.getItem('mssidcuserid'),
        interventionId: this.form.get('intervention')?.value,
        componentId: this.form.get('component')?.value,
        questionIds: this.selectedQuestions
      }
      this.apiService.postRequest(API_ENDPOINTS.MSSIDC.POSTCUSTOMFEEDBACKINTERCOPM, data).subscribe(
        (result: any) => {
          if (result.status) {
            
            this.toastrService.success('Implementation Details added successfully!', 'Success');
            window.location.reload();
          } else {
            this.toastrService.error('Failed to submit data.', 'Error');
          }
        },
        error => {
          this.toastrService.error('An error occurred while submitting the data.', 'Error');
        }
      );
    }

  }

}
